import type { CalendarPersonProfile } from '../EventComponent/EventComponent.types';

export const getCalendarPersonDisplayName = (person: CalendarPersonProfile): string => {
  const fullName = `${person.first_name || ''} ${person.last_name || ''}`.trim();
  return fullName || 'Unknown';
};
